export default __webpack_public_path__ + "static/media/OpenSans-SemiBold.2f17aae8.ttf";